export default {
  loading: false,
  shipperEvents: [],
  shipperForm: {
    micro: {
      id: null,
    },
    macro: {
      id: null,
    },
    base: {
      code: null,
      description: null,
    },
  },
};



// WEBPACK FOOTER //
// ./src/features/private/settings/pages/manage-events-order/pages/event-shipper/store/states.js